const TransactionType = {
  PAYMENT: 1,
  RECURRENCE: 2,
};
export default TransactionType;
